import { createImg } from "../../../DomUtilities/ElementsCreator";
import ItemCategory from "../../../Models/ItemCategory";
import Mediator from "../../../Utilities/Mediator";
import OrderHandler from "../OrderHandler";

export default class ItemTile {
	item: ItemCategory;
	itemTile: HTMLDivElement;

	constructor(itemCategory: ItemCategory) {
		this.item = itemCategory;

		this.init();
	}

	private init() {
		this.createItemTile();
		this.addItemCLickListener();
	}

	private createItemTile() {
		const src: string = this.item.image ? this.item.image : "/assets/no_image_placeholder.png";
		const icon = createImg(src, `${this.item.name} ikon`);
		const iconWrapper = document.createElement('div');
		const name = document.createElement('p');

		this.itemTile = document.createElement('div');
		this.itemTile.id = this.item.id;
		name.innerText = this.item.name;

		iconWrapper.appendChild(icon);
		this.itemTile.appendChild(iconWrapper);
		this.itemTile.appendChild(name);
	}

	private addItemCLickListener() {
		this.itemTile.onclick = () => {
			this.selectItem();
		}
	}

	private selectItem() {
		OrderHandler.currentItems = new Array<ItemCategory>();
		OrderHandler.completedSelectedItems = new Set<string>();
		if (this.item.subItemsIds.length) {
			OrderHandler.currentItems =
				OrderHandler.items.filter(item => this.item.subItemsIds.includes(item.id));
			OrderHandler.currentItems.forEach((item, index) => {
				const time = new Date();
				time.setMilliseconds(100 * index);
				if (index === 0) {
					this.addSelectedItem(item, time.getTime().toString());
				}
				item.itemId = time.getTime().toString();
			});
		} else {
			OrderHandler.currentItems.push(this.item);
			this.addSelectedItem(this.item, new Date().getTime().toString());
		}
		Mediator.emit("itemSelected");
		OrderHandler.isFastTrack = false;
	}

	private addSelectedItem(itemCategory: ItemCategory, itemId: string) {
		const item = new ItemCategory();
		item.id = itemCategory.id;
		item.itemId = itemId;
		item.name = itemCategory.name;
		item.image = itemCategory.image;
		item.hasSimpleOrderFlow = itemCategory.hasSimpleOrderFlow;
		OrderHandler.selectedItem = item;
	}
}
